import React from "react";
import * as XLSX from "xlsx";
import { saveAs } from "file-saver";
import { Button } from "@mui/material";

const SampleFile = () => {
  // Function to download Excel with only headers
  const downloadExcel = () => {
    const columnHeaders = [
      ["Opening Balance On", "Opening Balance", "Total Deposits (Credits)", "Total Cheques (Debits)", "Account Fees", "Closing Balance On", "Closing Balance"]
    ];

    // Create a new worksheet and add headers
    const ws = XLSX.utils.aoa_to_sheet(columnHeaders);

    // Create a new workbook and append the worksheet
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "Users Report");

    // Create a Blob and trigger download
    const excelBuffer = XLSX.write(wb, { bookType: "xlsx", type: "array" });
    const data = new Blob([excelBuffer], { type: "application/octet-stream" });
    saveAs(data, "SampleFile.xlsx");
  };

  return (
    <div className="p-1">
  
      <Button
        onClick={downloadExcel}
        variant="contained" 
      >
        Sample File
      </Button>
    </div>
  );
};

export default SampleFile;
